/*
 * @Descripttion: 可付款订单列表页State
 * @Author: 曹博
 * @Date: 2023-12-06 14:35:54
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-06 14:49:25
 */
import { ActionType, CustomAction } from '../../global'

export interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: any[]
  isTableLoading?: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 0,
    current: 1,
    pagesize: 50,
  },
  searchParam: {},
  selectedRows: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (
  val: PaginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})
/*
 * @Descripttion: 可付款订单列表页State
 * @Author: 曹博
 * @Date: 2023-12-06 14:35:54
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-06 14:49:25
 */
import { ActionType, CustomAction } from '../../global'

export interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: any[]
  isTableLoading?: boolean
  paginationOption: PaginationOption
  searchParam: any
  selectedRows: any[]
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 0,
    current: 1,
    pagesize: 50,
  },
  searchParam: {},
  selectedRows: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
export const setPaginationOptionAction = (
  val: PaginationOption,
): CustomAction<Action> => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSourceAction = (val: any): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})
